import { ESmsLogStatuses } from './sms-log'

export type THRContact = {
  id: number
  phone: string
  firstname: string | null
  lastname: string | null
  role: string | null
  serviceUnit: string | null
  remoteId: string | null
  isPhoneValid: boolean
  importedAt: string | null
  CommunicationChannelId: number | null
  ProjectId: number
  deletedAt: string | null
}

export enum ECampaignType {
  ALERT = 'ALERT',
  PLAN_BLANC = 'PLAN_BLANC',
}

export enum ECampaignStatus {
  SENDING = 'SENDING',
  SENT = 'SENT',
}

export type THRCampaign = {
  id: number
  type: ECampaignType
  status: ECampaignStatus
  message: string
  sentAt: string
  recipientCount: number
  ProjectId: number
  kpis?: {
    pending: number
    completed: number
    superseded: number
  }
}

export enum EHRDispatchStatus {
  PENDING = 'PENDING',
  SUPERSEDED = 'SUPERSEDED',
  COMPLETED = 'COMPLETED',
  UNREACHABLE = 'UNREACHABLE',
}

export enum EHRDelay {
  MIN_30 = 'MIN_30',
  H1 = 'H1',
  H2 = 'H2',
  UNAVAILABLE = 'UNAVAILABLE',
  PENDING_REVIEW = 'PENDING_REVIEW',
}

export type THRCampaignDispatch = {
  id: number
  status: EHRDispatchStatus
  delay: EHRDelay | null
  rawResponse: string | null
  respondedAt: string | null
  smsStatus: ESmsLogStatuses | null
  CampaignId: number
  HRContactId: number
  ProjectId: number
  HRContact: THRContact
}

export type THRSmsLog = {
  id: number
  inbound: boolean
  message: string
  status: ESmsLogStatuses
  sentAt: string
  deliveredAt: string | null
  label: 'hr:initial' | 'hr:response' | null
  CampaignDispatchId: number
  type: 'text' | 'image'
}

export type THRCreateCampaignRequest = {
  type: ECampaignType
  message: string
  hrContactIds: number[]
}

export type THRSendMessengerRequest = {
  message: string
}

export type THRDispatchSocketPayload = {
  id: number
  status: EHRDispatchStatus
  smsStatus: string | null
  delay: EHRDelay | null
  rawResponse: string | null
  respondedAt: string | null
  CampaignId: number
  HRContactId: number
  ProjectId: number
}

export type THRDispatchUpdatedPayload = {
  campaignId: number
  dispatch: THRDispatchSocketPayload
}

export type THRDispatchNewSmsPayload = {
  campaignId: number
  dispatchId: number
  smsLog: THRSmsLog
}

export type THRDispatchSmsStatusChangePayload = {
  campaignId: number
  dispatchId: number
  smsLogId: number
  newStatus: string
}

export type THRDispatchCreatedPayload = {
  campaignId: number
  dispatch: THRDispatchSocketPayload & {
    createdAt: string
    updatedAt: string
    HRContact: THRContact
  }
}

export type THRCampaignStatusUpdatedPayload = {
  campaignId: number
  newStatus: ECampaignStatus
}
